import { AccountTypeDto } from 'src/dtos';

interface AccountTypeDescriptionProps {
  value?: AccountTypeDto;
}

export const AccountTypeDescription = ({ value }: AccountTypeDescriptionProps) => {
  if (value === AccountTypeDto.Individual || value === AccountTypeDto.Retirement) {
    return (
      <>A standard account with a sole owner. Any assets are passed to the account owner’s estate if owner passes.</>
    );
  }

  if (value === AccountTypeDto.Joint) {
    return <>A brokerage account owned by two or more people. Select the Joint account suitable for you.</>;
  }

  if (value === AccountTypeDto.Ugma) {
    return (
      <>
        A Custodial Uniform Gift to Minors Act (UGMA) account held in the name of a minor but controlled by a parent or
        other relative until the minor achieves the age of majority in their state. Non‒resident aliens do not qualify
        for this account type.
      </>
    );
  }

  return null;
};
